/** (授信、用信)验证信息: 基本信息、联系人、身份证、活体、二要素 */
export enum VerifyStageEnum {
  USER_BASE = 'userBase',
  CONTACT_INFO = 'contactInfo',
  ID_CARD = 'idCard',
  BIO_AUTH = 'bioAuth',
  TWO_ELEMENTS = 'nameAndIdCardNo',
}

/** 资料填写-场景值(决定关键流程) */
export enum VerifySceneEnum {
  /**
   * 极简专用流程：
   * ps，通过isSimple接口服务判断为true的场景使用(目前授信阶段线上100%是极简用户，可忽略isSimple的判断)
   */
  /** 授信-前置核验 (ocr、活体) */
  CREDIT_PRE_VERIFY = 'credit_pre_verify',
  /** 授信-(中段)仅ocr补充：ocr未补充，授信任务挂起，跳转此场景补充ocr */
  CREDIT_MIDDLE_ONLY_OCR = 'credit_middle_only_ocr',
  /** 授信-前置核验 (ocr后置流程) */
  CREDIT_PRE_VERIFY_OCR_AFTER = 'credit_pre_verify_ocr_after',
  /** 授信-后置资料补充 */
  CREDIT_POST_SUPPLEMENT = 'credit_post_supplement',
  /** 提现-所有资料填写(包含：兜底补充)(1. Api外采提现场景) */
  LOAN_UNION_SUPPLEMENT = 'loan_union_supplement',
  /** 二要素核验: 姓名、身份证号，如绑卡流程 */
  TWO_ELEMENTS_VERIFY = 'two_elements_verify',
  /** 授信-前置资料补充完整 + 授信订单提交(包含：授信协议签署) */
  CREDIT_SUPPLEMENT_AND_SUBMIT = 'credit_supplement_and_submit',

  /**
   * 预授信专用流程：
   * 第一阶段，preCreditFirstInfo：实名认证
   * 第二阶段：preCreditAddInfo：基本信息、联系人、活体验证
   */
  PRE_CREDIT_FIRST_INFO = 'pre_credit_first_info',
  PRE_CREDIT_ADD_INFO = 'pre_credit_add_info',

  /**
   * 个人信息资料补充专用流程：
   * ps，已填写个人信息 & supplyNeedConfig接口返回有需要补充的字段
   */
  /** 授信-补充个人信息字段(场景：你我贷-补充“ 婚姻、行业、职业”) */
  CREDIT_SUPPLY_PERSONAL = 'credit_supply_personal',
  /** 提现-补充个人信息字段 - 线上提现页补充资料场景(例如补充“ 婚姻、职业、所属行业”) */
  LOAN_SUPPLY_PERSONAL = 'loan_supply_personal',

  /**
   * 授信、提现流程-资料验证，不区分是否极简用户 && 不区分阶段：
   * ps，全逻辑后置到服务端
   * 若不知道是 CREDIT_PRE_VERIFY 还是 CREDIT_POST_SUPPLEMENT场景，可用此场景
   */
  CREDIT_MIX_SUPPLEMENT = 'credit_mix_supplement',

  /**
   * 特定场景的定制化信息填写流程：
   */
  /** 过期身份证-更新：首页-身份证30天即将过期 */
  UPDATE_EXPIRES_IDENTITY = 'update_expires_identity',
  /** 授信流程(一般是非极简)-身份证信息异常，接入场景：（清晰分不足、实名不一致） */
  CREDIT_WITH_INVALID_IDENTITY = 'credit_with_invalid_identity',
  /** “个人信息”修改，接入场景：设置页-个人信息 */
  PERSONAL_PROFILE_MODIFY = 'personal_profile_modify',
  /** “联系人信息”修改，接入场景：设置页-联系人信息 */
  PERSONAL_CONTACT_MODIFY = 'personal_contact_modify',
  /** “身份证信息”修改，接入场景：设置页-实名认证、已授信用户身份证清晰分不足 */
  PERSONAL_IDENTITY_MODIFY = 'personal_identity_modify',
  /** 营销流程-前置信息补充，接入场景：短信营销(fromSms) */
  MARKET_PRE_SUPPLEMENT = 'market_pre_supplement',
  /** 个人信息、联系人信息补充，接入场景：needEducation、needMonthSalary、needEmergencyContact */
  USER_BASE_CONTACT_SUPPLEMENT = 'user_base_contact_supplement',
  /** 姓名修改(个人姓名、联系人姓名)，接入场景：提现-姓名不对进行修正 */
  PERSONAL_NAME_MODIFY = 'personal_name_modify',

  /**
   * 活动场景流程：
   */
  /** 授信现金活动：上传完OCR后直接结束，下发现金红包，无需活体 */
  CREDIT_CASH_ACTIVITY = 'credit_cash_activity',

  /**
   * 零用钱流程场景：
   * 流程和预授信一致，标题与提交按钮文案有定制
   */
  /** 零用钱第一阶段：实名认证，同预授信第一阶段 */
  POCKET_MONEY_FIRST_INFO = 'pocket_money_first_info',
   /** 分期商城 */
  PRE_CREDIT_FQ_SHOPPING = 'pre_credit_fq_shopping',
  /** 授信失败实验组二分期商城场景 */
  PRE_CREDIT_FQ_SHOPPING_2 = 'pre_credit_fq_shopping_2',
}

/** 打开检验页面-模式 */
export enum OpenVerifyPageMode {
  /** router页面跳转 */
  ROUTER_JUMP = 'router_jump',
  /** pop弹窗展示 */
  POPUP_SHOW = 'popup_show'
}

export interface StartVerifyCreditOptions {
  successCb?: (params?: Dictionary<string>) => void,
  failCb?: (params?: Dictionary<string>) => void,
  /** 动态参数 */
  queryParams?: Record<string, unknown>,
  /** 打开模式：弹窗、spa */
  openMode?: OpenVerifyPageMode,
  /** spa模式history是否使用replace */
  useReplace?: boolean,
  /** 渠道ids */
  commodityIds?: number[] | string[],
  /** 授信任务id */
  creditId?: string | number,
}

/**
 * 场景附属类型参数，用于决定 挽留弹窗定制化文案、用户行为附加埋点...
 * 对应，调用资料填写参数：queryParams.type
 */
export enum VerifyQueryParamsTypeEnum {
  /** 短信营销 */
  FromSms = 'fromSms',
  /** 提现页 */
  ApplyProduct = 'applyProduct',
  /** 提现页-未绑银行的场景 */
  ApplyForNoBankCard = 'applyForNoBankCard',
  /** 绑卡页 */
  CardBind = 'cardBind',
}

/**
 * 触发成功回调阶段
 */
export enum ResolveVerifyStageEnum {
  /** 初始化 */
  INIT = 'init',
  /** 操作完成 */
  OPERATION_COMPLETE = 'operationComplete',
}

/**
 * 表现层主题样式
 */
export enum PresentationThemeEnum {
  /**
   * 平台蓝色主题样式
   */
  PLATFORM_BLUE = 'platform-blue',
}

/**
 * 表现层配置
 * 用于控制身份认证页面展示，如样式、文案等
 */
export interface PresentationConfig {
  /** 主题样式 */
  theme?: PresentationThemeEnum;
  /** 身份证认证阶段配置 */
  [VerifyStageEnum.ID_CARD]?: {
    /** 标题文案 */
    title?: string;
    /** 规则文案 */
    ruleText?: string;
    /** 提交按钮文案 */
    submitText?: string;
  };
}
